import { mergeTemplate } from './base-template';

export const arztTemplate = mergeTemplate({
  name: 'Arztpraxis',
  icon: '🩺',
  settings: {
    primaryColor: '#15803d',
    accentColor: '#258274',
    fontStack: 'dmsans',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Unsere Leistungen',
      heroSubtitle: 'Medizinische Versorgung auf höchstem Niveau',
      packages: [
        { name: 'Grundversorgung', price: 'Grundversicherung', description: 'Allgemeinmedizinische Betreuung', features: 'Konsultation, Vorsorgeuntersuchung, Labordiagnostik, Überweisung', highlighted: false },
        { name: 'Zusatzleistungen', price: 'nach Tarmed', description: 'Erweiterte medizinische Services', features: 'Sportmedizin, Ernährungsberatung, Reisemedizin, Psychosomatik', highlighted: true },
        { name: 'Check-up Pakete', price: 'ab CHF 350', description: 'Umfassende Gesundheitsvorsorge', features: 'Blutbild, Herz-Kreislauf, Stoffwechsel, persönliches Beratungsgespräch', highlighted: false },
      ],
      ctaTitle: 'Ihre Gesundheit liegt uns am Herzen',
      ctaText: 'Vereinbaren Sie Ihren Termin — wir nehmen uns Zeit für Sie.',
      ctaButtonText: 'Termin buchen',
    },
    pageMethoden: {
      heroTitle: 'Unser Behandlungskonzept',
      heroSubtitle: 'Evidenzbasiert, ganzheitlich, patientenzentriert',
      introText: 'Wir verbinden modernste Diagnostik mit einem persönlichen, ganzheitlichen Behandlungsansatz.',
      steps: [
        { title: 'Anamnese', description: 'Ausführliches Gespräch über Ihre Beschwerden und Krankengeschichte' },
        { title: 'Diagnostik', description: 'Gezielte Untersuchungen und Labor für eine fundierte Diagnose' },
        { title: 'Therapie', description: 'Individueller Behandlungsplan mit klaren Massnahmen' },
        { title: 'Nachsorge', description: 'Kontrollen, Anpassungen und langfristige Gesundheitsbegleitung' },
      ],
      tools: [
        { name: 'Modernes Labor', description: 'Schnelle Ergebnisse durch hauseigene Diagnostik' },
        { name: 'Digitale Patientenakte', description: 'Sichere, vernetzte Dokumentation' },
        { name: 'Telemedizin', description: 'Videokonsultationen für Nachkontrollen' },
      ],
      philosophyTitle: 'Unsere Medizin-Philosophie',
      philosophyText: 'Der Mensch steht im Mittelpunkt — nicht die Krankheit. Wir behandeln Patienten, nicht Symptome.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Praxis-Team',
      heroSubtitle: 'Kompetent, empathisch, engagiert',
      introText: 'Unser Team aus erfahrenen Ärztinnen, Ärzten und medizinischen Fachpersonen betreut Sie umfassend.',
      imageUrl: '',
      timeline: [
        { year: '2005', text: 'Gründung der Praxis' },
        { year: '2015', text: 'Erweiterung um Spezialsprechstunden' },
        { year: '2022', text: 'Einführung Telemedizin' },
      ],
      values: [
        { title: 'Empathie', description: 'Zuhören, verstehen, gemeinsam entscheiden' },
        { title: 'Evidenz', description: 'Behandlungen auf Basis aktueller medizinischer Forschung' },
        { title: 'Erreichbarkeit', description: 'Kurze Wartezeiten und flexible Terminvergabe' },
      ],
      certifications: 'FMH Allgemeinmedizin, Notfallmedizin SGNOR',
    },
  },
  components: {
    header: {
      companyName: 'Praxis Muster',
      logoText: 'PM',
      navItems: ['Leistungen', 'Methoden', 'Praxis', 'Kontakt'],
      ctaText: 'Termin anfragen',
    },
    hero: {
      title: 'Medizin mit Ruhe und Struktur',
      subtitle:
        'Sprechstunden, Diagnostik und Betreuung – klar organisiert.',
      primaryBtn: 'Termin anfragen',
      secondaryBtn: 'Leistungen',
    },
    trust: {
      items: [
        { value: 'Empathisch', label: 'Betreuung' },
        { value: 'Strukturiert', label: 'Abläufe' },
        { value: 'Modern', label: 'Praxis' },
        { value: 'Erreichbar', label: 'Kontakt' },
      ],
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Ausgewählte Schwerpunkte.',
      items: [
        {
          icon: '🩻',
          title: 'Abklärung',
          text: 'Sorgfältige Diagnostik und Einordnung.',
        },
        {
          icon: '💊',
          title: 'Behandlung',
          text: 'Therapieplanung und Begleitung.',
        },
        {
          icon: '📋',
          title: 'Vorsorge',
          text: 'Check-ups und Prävention.',
        },
      ],
    },
    team: {
      title: 'Team',
      subtitle: 'Sprechstunde und Betreuung.',
      members: [
        {
          name: 'Dr. Muster',
          role: 'Facharzt',
          image: '',
          bio: 'Schwerpunkt: Allgemeinmedizin.',
        },
        {
          name: 'Sarah Brunner',
          role: 'Medizinische Praxisassistentin',
          image: '',
          bio: 'Empfang, Labordiagnostik und Patientenbetreuung.',
        },
      ],
    },
    testimonials: {
      title: 'Patientenstimmen',
      items: [
        {
          quote: 'Nimmt sich Zeit, hört zu und erklärt verständlich.',
          author: 'Patient',
          role: '',
        },
        {
          quote: 'Kurze Wartezeiten und eine sehr freundliche Praxisatmosphäre. Fühle mich bestens betreut.',
          author: 'Ursula K.',
          role: 'Patientin seit 2018',
        },
        {
          quote: 'Die Telemedizin-Sprechstunde ist sehr praktisch — spart Zeit und funktioniert einwandfrei.',
          author: 'Jonas W.',
          role: 'Berufstätiger Patient',
        },
        {
          quote: 'Endlich eine Praxis, die mich als ganzen Menschen sieht und nicht nur Symptome behandelt.',
          author: 'Barbara F.',
          role: 'Patientin',
        },
        {
          quote: 'Dr. Muster hat mir den Gesundheits-Check-up empfohlen. Sehr froh, dass ich es gemacht habe.',
          author: 'Reto M.',
          role: 'Vorsorge-Patient',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Wie buche ich einen Termin?',
          answer:
            'Kontaktieren Sie uns telefonisch oder per E-Mail. Online-Buchung kann ergänzt werden.',
        },
        {
          question: 'Nehmen Sie neue Patienten auf?',
          answer: 'Ja, wir freuen uns über neue Patientinnen und Patienten. Bitte kontaktieren Sie uns für einen Ersttermin — wir nehmen uns gerne Zeit für ein ausführliches Erstgespräch.',
        },
        {
          question: 'Bieten Sie auch Telemedizin an?',
          answer: 'Ja, für Nachkontrollen und Besprechungen bieten wir Videokonsultationen an. So sparen Sie Anfahrtszeit und erhalten trotzdem eine persönliche Betreuung.',
        },
        {
          question: 'Was kostet ein Gesundheits-Check-up?',
          answer: 'Unsere Check-up-Pakete starten ab CHF 350. Der genaue Umfang wird individuell mit Ihnen besprochen. Einige Zusatzversicherungen übernehmen einen Teil der Kosten.',
        },
      ],
    },
    cta: {
      title: 'Termin anfragen',
      subtitle: 'Wir melden uns zeitnah.',
    },
    footer: {
      companyName: 'Praxis Muster',
      tagline: 'Ihre Praxis in der Region.',
    },
  },
});
